module.exports = __webpack_public_path__ + "img/dineOut_0318_2.57c643c7.png";